import React from 'react';
import { PressComment, TextAndImage } from '@noths/polaris-client-ribbons-design-system';

import type { PartnerContentState } from 'src/redux/content/types';
import * as styles from './PartnerStory.styles';

interface PartnerStoryProps {
  partnerContent: PartnerContentState;
}

export const PartnerStory = ({ partnerContent }: PartnerStoryProps) => {
  return (
    <>
      <div css={styles.container}>
        <TextAndImage
          body={partnerContent.storyText || ''}
          heading="About"
          images={partnerContent.storyImages ?? []}
          subHeading={partnerContent.storySummary || ''}
          textColumn="left"
        />
        {partnerContent.moreAboutYou && (
          <TextAndImage
            body={partnerContent.moreAboutYou.text || ''}
            heading={partnerContent.moreAboutYou.summary || ''}
            images={partnerContent.moreAboutYou.image ? [partnerContent.moreAboutYou.image] : []}
            textColumn="right"
          />
        )}
        {partnerContent.pressComments?.length ? (
          <section css={styles.pressCommentsSection}>
            <h2>Press comments</h2>
            <ul>
              {partnerContent.pressComments.map((comment) => (
                <li key={`${comment.author}-${comment.date}`}>
                  <PressComment
                    comment={comment.text}
                    date={comment.date}
                    href={comment.link}
                    source={comment.author}
                  />
                </li>
              ))}
            </ul>
          </section>
        ) : null}
      </div>
    </>
  );
};
